<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15 16H1a.93.93 0 0 1-1-.833v-3.332A.931.931 0 0 1 1 11h14a.93.93 0 0 1 1 .835v3.332A.929.929 0 0 1 15 16Zm-2.5-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" fill="currentColor"/><path d="M7.727 10.244.738 3.692A.4.4 0 0 1 1.012 3H5V0h6v3h3.99a.4.4 0 0 1 .274.691l-6.993 6.553a.4.4 0 0 1-.547 0h.003Z" opacity=".45" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering08',
});
</script>
